import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSync } from "@fortawesome/free-solid-svg-icons";
import RapidCareLogo from "../../../assets/images/rapid-care-logo2.png";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Error caught by ErrorBoundary:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="container-fluid d-flex flex-column align-items-center text-center"
          style={{
            minHeight: "100vh",
            backgroundColor: "#fff",
            padding: "2rem",
          }}
        >
          <div className="w-100 d-flex justify-content-center mb-4">
            <img
              src={RapidCareLogo}
              alt="logo"
              className="img-fluid"
              style={{ maxHeight: "100px" }}
            />
          </div>

          <div className="flex-grow-1 d-flex flex-column justify-content-center align-items-center">
            <h1 className="display-4 font-weight-bold">Oops!</h1>
            <h4 className="mb-3" style={{ color: "#325ba6" }}>
              Something went wrong...
            </h4>
            <p className="text-muted mb-4">
              An unexpected error occurred. Please try refreshing the page.
            </p>
            <div className="d-flex justify-content-center">
              <button
                onClick={() => window.location.reload()}
                className="btn btn-primary d-flex align-items-center"
              >
                <FontAwesomeIcon
                  icon={faSync}
                  className="mr-2"
                  style={{ height: "15px", width: "15px" }}
                />
                Reload Page
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
